import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex my-1"
};
const _hoisted_2 = {
  class: "rounded overflow-hidden flex items-stretch mr-1"
};
const _hoisted_3 = {
  class: "grow flex items-center"
};
const _hoisted_4 = {
  key: 0,
  class: "flex items-center mx-1"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import PlayerForm from "@/modules/team/components/PlayerForm.vue";
import PlayerEnergy from "@/modules/team/components/PlayerEnergy.vue";
import Position from "@/modules/team/components/Position.vue";
import Skill from "@/modules/team/components/Skill.vue";
import Card from "@/modules/match/components/Card.vue";
import Talent from "@/modules/youth/components/Talent.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Player',
  props: {
    player: null,
    vertical: {
      type: Boolean
    },
    hideCountry: {
      type: Boolean
    },
    hideAge: {
      type: Boolean
    },
    hideConstitution: {
      type: Boolean
    },
    hideEnergy: {
      type: Boolean
    },
    hideForm: {
      type: Boolean
    },
    suspension: null,
    noLink: {
      type: Boolean
    },
    showTalent: {
      type: Boolean
    },
    nextMatch: null
  },
  setup(__props) {
    const props = __props;
    const suspension = computed(() => {
      if (!props.nextMatch) {
        return null;
      }
      return props.player.suspensions.find(s => s.competitionId === props.nextMatch.matchday.division.competitionId);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["grow flex leading-4", {
          'flex-col items-start': __props.vertical,
          'items-center': !__props.vertical
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["flex items-center", {
          'mb-1': __props.vertical
        }])
      }, [__props.showTalent ? (_openBlock(), _createBlock(Talent, {
        key: 0,
        talent: __props.player.revealedTalent,
        class: "mr-0.5"
      }, null, 8, ["talent"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_unref(suspension) ? (_openBlock(), _createBlock(Position, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(Card, {
          card: _unref(suspension).card
        }, null, 8, ["card"])]),
        _: 1
      })) : (_openBlock(), _createBlock(Position, {
        key: 1,
        position: __props.player.position
      }, null, 8, ["position"])), _createVNode(Skill, {
        skill: __props.player.skill
      }, null, 8, ["skill"])]), !__props.hideCountry ? (_openBlock(), _createBlock(Flag, {
        key: 1,
        country: __props.player.country,
        class: "mr-1"
      }, null, 8, ["country"])) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_3, [!__props.hideConstitution ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "end", {}, () => [!__props.hideEnergy ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(PlayerEnergy, {
        player: __props.player,
        class: "mr-1"
      }, null, 8, ["player"])])) : _createCommentVNode("", true), !__props.hideForm ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(PlayerForm, {
        player: __props.player
      }, null, 8, ["player"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", {
          'text-green-600': __props.player.team && __props.player.team.user,
          'text-red-600': __props.player.endsCareer
        }])
      }, [_createVNode(EntityLink, {
        entity: __props.player,
        "hide-age": __props.hideAge,
        disabled: __props.noLink
      }, null, 8, ["entity", "hide-age", "disabled"])], 2)])], 2)]);
    };
  }
});